import _ from "lodash";

const getFilteredProductList = (filters, productList, filtersToSkip = {}) => {
  return _.filter(productList, (product) => {
    let filterCondition = true;
    if (filters.product && !filtersToSkip.product)
      filterCondition =
        filterCondition &&
        !!Array.from(filters.product).some((obj) => obj.id === product.id);
    if (filters.brand)
      filterCondition =
        filterCondition &&
        !!Array.from(filters.brand).some((obj) => obj.id === product.brand_id);
    if (filters.line)
      filterCondition =
        filterCondition &&
        !!Array.from(filters.line).some((obj) => obj.id === product.line?.id);
    if (filters.category && product.line?.categories) {
      if (!filters.line) {
        filterCondition =
          filterCondition &&
          filters.category.some((obj) =>
            product.line.categories.some(
              (productCategory) => productCategory.id === obj.id
            )
          );
      }
    }
    return filterCondition;
  });
};

export default getFilteredProductList;
